module.exports = __webpack_public_path__ + "img/3.f402e0c4.webp";